import { Typography, Box } from '@mui/material';
import Accordion from 'src/components/section/Accordion';

const FAQAccordion = ({ questions = [] }) => {
  return (
    <Accordion subtitle={`FAQ`}>
      {questions.map(({ question, answer }, index) => {
        return (
          <Box key={index} sx={{ margin: '1rem' }}>
            <Typography style={{ fontWeight: 'bold' }}>{question}</Typography>
            <Typography>{answer}</Typography>
          </Box>
        );
      })}
    </Accordion>
  );
};

export default FAQAccordion;
